import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../helpers/request.helper';
import { authSuccessAction } from '../actions/creators/auth.actioncreator';
import {
  SSO_REQUEST,
  SSO_FAILURE,
} from '../actions/constants/sso.constants';

function* ssoLogin({ payload: { ssotoken } }) {
  const ssoObject = JSON.parse(decodeURIComponent(escape(window.atob(ssotoken))));
  const { token, action } = ssoObject;
  const options = {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };
  try {
    const { user, permisos } = yield call(request, 'api/permisos', 'GET', null, options);
    yield put({ type: 'NAVIGATION_DISABLE', payload: { redirect: action } });
    yield put(authSuccessAction(token, user, permisos));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Invalid credentials';
        break;
      default:
        message = 'Something went wrong';
    }
    yield put({ type: SSO_FAILURE, payload: message });
  }
}

function* ssoRequest() {
  yield takeLatest(SSO_REQUEST, ssoLogin);
}

export default ssoRequest;
